module.exports = __webpack_public_path__ + "static/media/0044_Small.92c3db0b.jpg";